import Root from "../layouts/Root";
import TrackTable from "../components/art/TrackTable";
import PaintingGallery from "../components/art/PaintingGallery";
import {faSquareInstagram} from "@fortawesome/free-brands-svg-icons/faSquareInstagram";
import IconText from "../components/IconText";
import {faMusic, faPalette} from "@fortawesome/free-solid-svg-icons";

export default function Art() {

    const rightContent = (
        <div>
            <h1><IconText icon={faMusic} text={"Music"}/></h1>
            <p>I generally produce electronic dance music, but I also experiment with other genres.</p>

            <TrackTable/>
            
            <h1><IconText icon={faPalette} text={"Paintings"}/></h1>
            <p>I enjoy the portrait paintings the most. <br/>
                Painting itself used to be my main focus, but nowadays I only paint to use it on my other projects.</p>
            <PaintingGallery/>
        </div>
    )
    return (
        <div className="art-page">
            <Root rightContent={rightContent}/>
        </div>
    )
}
